import { createSlice } from "@reduxjs/toolkit";
import {
  getAllFlightPlaces,
  getAllServicesForHome,
  getFlightPlaces,
  getTourServiceDetailByURL,
} from "./services/home.services";
import moment from "moment";

const initialState = {
  loading: false,
  fromLoading: false,
  toLoading: false,
  error: "",
  flightPlaces: [],
  services: [],
  sectors: [],
  flightSearchDetails: {
    formKey: 0,
    from: "AMD",
    fromOptions: [
      {
        city_name: "Ahmedabad",
        flightplace_code: "AMD",
        flightplace_name: "Sardar Vallabhbhai Patel International Airport",
      },
    ],
    triptype: "One Way",
    to: "BOM",
    toOptions: [
      {
        city_name: "Mumbai",
        flightplace_code: "BOM",
        flightplace_name: "Chhatrapati Shivaji Maharaj International Airport",
      },
    ],
    departureDate: moment().toISOString(),
    returnDate: moment().toISOString(),
    ADULT: 1,
    CHILD: 0,
    INFANT: 0,
    cabinClass: "Economy",
    specialfare: "Regular",
    traveller: null,
    multicities: [
      {
        from: "AMD",
        to: "BOM",
        fromCity: "Ahmedabad",
        toCity: "Pune",
        departureDate: moment().toISOString(),
        fromOptions: [
          {
            city_name: "Ahmedabad",
            flightplace_code: "AMD",
            flightplace_name: "Sardar Vallabhbhai Patel International Airport",
          },
        ],
        toOptions: [
          {
            city_name: "Mumbai",
            flightplace_code: "BOM",
            flightplace_name:
              "Chhatrapati Shivaji Maharaj International Airport",
          },
        ],
      },
      {
        from: "BOM",
        to: "DEL",
        fromCity: "Mumbai",
        toCity: "Delhi",
        departureDate: moment().add(1, "day").toISOString(),
        fromOptions: [
          {
            city_name: "Mumbai",
            flightplace_code: "BOM",
            flightplace_name:
              "Chhatrapati Shivaji Maharaj International Airport",
          },
        ],
        toOptions: [
          {
            city_name: "Delhi",
            flightplace_code: "DEL",
            flightplace_name: "Delhi Indira Gandhi Intl",
          },
        ],
      },
    ],
  },
  TourServiceDetails: {
    ID: null,
    Title: "",
    Image: "",
    URL: "",
    ShortDescription: "",
    LongDescription: "",
  },
};

const packageListSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setFlightSearchDetails: (state, action) => {
      state.flightSearchDetails = action.payload;
    },
    clearFlightSearchDetails: (state) => {
      state.flightSearchDetails = initialState.flightSearchDetails;
    },
    clearTourServiceDetails: (state) => {
      state.TourServiceDetails = initialState.TourServiceDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFlightPlaces.pending, (state) => {
      state.fromLoading = true;
    });
    builder.addCase(getFlightPlaces.fulfilled, (state, action) => {
      state.fromLoading = false;
      state.flightPlaces = action.payload;
      state.error = "";
    });
    builder.addCase(getFlightPlaces.rejected, (state, action) => {
      state.fromLoading = false;
      state.flightPlaces = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllServicesForHome.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllServicesForHome.fulfilled, (state, action) => {
      state.loading = false;
      state.services = action.payload?.TourServices || [];
      state.sectors = action.payload?.Sector || [];
      state.error = "";
    });
    builder.addCase(getAllServicesForHome.rejected, (state, action) => {
      state.loading = false;
      state.services = [];
      state.sectors = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getTourServiceDetailByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTourServiceDetailByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.TourServiceDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getTourServiceDetailByURL.rejected, (state, action) => {
      state.loading = false;
      state.TourServiceDetails = initialState.TourServiceDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setFlightSearchDetails,
  clearFlightSearchDetails,
  clearTourServiceDetails,
} = packageListSlice.actions;
export default packageListSlice.reducer;
